import { useFetcher, useLocation } from "@remix-run/react";

import { Button } from "@chakra-ui/react";
import { ArrowForwardIcon as UpgradeIcon } from "@chakra-ui/icons";

export function ManageSubscriptionButton({
  children = "Manage Subscription",
  returnTo,
  ...rest
}) {
  const location = useLocation();

  // This can maybe be useSubmit instead with a one button form
  const fetcher = useFetcher();
  const isLoading = fetcher.state === "submitting";

  return (
    <Button
      colorScheme="brand"
      rightIcon={<UpgradeIcon />}
      {...rest}
      isLoading={isLoading}
      onClick={() =>
        fetcher.submit(
          {
            returnTo: returnTo || location.pathname,
          },
          {
            action: "/api/stripe/portal",
            method: "POST",
          },
        )
      }
    >
      {children}
    </Button>
  );
}
